import React from 'react';
import  {IndexLink,Link,withRouter} from 'react-router';
import axios from 'axios';
import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Splash_Signin from "../../homecomponents/commons/splash_signin";
import Loading from 'react-loading';
import ProfileReviews from "../../appcomponents/commons/profile/profile_review";

class InternshipPublic extends React.Component{
	constructor(props) {
		super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
			joined: 0,
			rst: [],
			skillArr: [],
			studentItem: [],
			tasks:[],

			menuShow: false,

			verified: false,
		}
	}

	componentWillMount = () => {
		this.getProject()
	}

	componentDidMount = () => {}

	componentWillUnmount = () => {}

	componentWillReceiveProps = (nextProps) => {}

	getProject = () => {
		var url = "/code/api_projects.php?api=getProjectDetail";
		var data = new FormData();
		data.append("jk", this.props.params.jk);
		axios.post(url, data)
			.then(response => {
				this.setState({rst: response.data.data, tasks: response.data.data.tasks, joined: response.data.data.isJoined}, () => {
					this.renderSkills()
				});
			}).catch(error => {
		});
	}

	renderSkills = () => {
		let skills = this.state.rst.skill;
		let skillArr = []

		for (var i = 0; i < skills.length; i++) {
			var label = skills[i]['lable'];
			skillArr.push(
				<li key={"skill-"+i} className="profile-skills__skill">
					<button className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view">
						<span className="artdeco-pill__text">#{label}</span>
					</button>
				</li>
			);
		}

		this.setState({skillArr: skillArr})
	}

	handleClickJoin = () => {
		this.props.router.push("/signup")
	}

	handleClick = (act) => {
		this.props.router.push(act);
	}

	mouseClick = (evt) => {
		this.setState({menuShow: !this.state.menuShow})
	}

	mouseOut = (evt) => {
		this.setState({menuShow: false})
	}

	mouseLinkClick = (link, evt) => {
		this.props.router.push(link);
	}

	handleVerified = () => {
		let verified = this.state.verified
		this.setState({verified: !verified})
	}

	render() {
		if (parseInt(this.state.rst.length) === 0) {
			return (
				<div className="app_page_wrapper">
					<div className="center_div"><Loading type='spinningBubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div>
				</div>
			);
		}
		console.log(this.state.rst)
		let ago = this.state.rst.ago
		let reward = this.state.rst.reward
		let allotted = this.state.rst.allotted
		let expires = this.state.rst.expires
		let master = this.state.rst.master
		let cost_extent = this.state.rst.cost_extent
		let enable_compress = this.state.rst.enable_compress
		let apprx = this.state.rst.apprx
		let incentive = this.state.rst.incentive
		let duration = this.state.rst.duration
		let team_type = this.state.rst.team_type
		let project_type = this.state.rst.project_type

		//View Post
		let company = this.state.rst
		let f_char = company.name_company.substring(0, 1).toUpperCase()
		let avatar =  company.avata ? company.avata :  f_char
		let imgUrl = company.banner ? company.banner : '/static/img/appimg/default-banner.png';

		// params for popover
		let item = this.state.rst
		let employer = item.employerProfile
		let coache = item.coacheProfile

		let coach_avatar = coache.avatar;
		let coach_name = coache.full_name;
		let coach_tagline = coache.tagline;
		let coach_id = coache.id_account;
		let isSupported = item.isSupported;

		return (
			<div>
				{isMobile ?
					<div className="advertise_boxx" id="a_project_mobile">
						<div className={"block-001 row mr0"}>
							<Link to="/"><img className={"img_logo"} style={{width: "90px"}} src="/static/img/appimg/top_login_h_logo.png"/></Link>
							<div className={"mobile-dropdown"}>
								<svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
									<title>Menu</title>
									<path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
								</svg>
								<ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
									<li onClick={() => this.mouseLinkClick("/employers/signup")}><span>Join</span></li>
									<li onClick={() => this.mouseLinkClick("/projects/signin")}><span>Sign in</span></li>
								</ul>
							</div>
						</div>
					</div>
					:
					<div id="company">
						<header>
							<div className="header">
								<div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
								<Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
							</div>
						</header>
						<div className="splash_wrapper"></div>
					</div>
				}
				{isMobile ?
					<div id="content" className="no-marging-top a_project_mobile">
						<div className="container root-linkedin" id="root-linkedin">
							<div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
								<main id="main" className="scaffold-layout__main">
									<div>
										<img
											src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
											className="hidden" data-elementtiming="true" alt="" role="none"/>
										<section id="ember3348" className="artdeco-card ember-view pv-top-card">
											<div className="live-video-hero-image"
												 style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
												<div tabIndex="0" aria-label="Profile background"
													 className="profile-background-image">
													<div className="profile-background-image__image-container">
														<img
															className={company.banner ? "profile-background-image__image full-width full-height" : "profile-background-image__image full-height"}
															id="profile-background-image-target-image"
															alt="Background Image"
															src={imgUrl}
														/>
													</div>
												</div>
											</div>

											<div className="ph5 pb5">
												<div className="display-flex pv-top-card--reflow">
													<div className="pv-top-card--photo text-align-left">
														<div className="pv-top-card__photo-wrapper image-no-radius ml0">
															<div className="presence-entity presence-entity--size-9 pv-top-card__image">
																{parseInt(avatar.length) === 1 ?
																	<span>{f_char}</span>
																	:
																	<img title="Avatar"
																		 src={avatar}
																		 className="presence-entity__image  pv-top-card__photo image-no-radius lazy-image ghost-person ember-view"/>
																}
															</div>
														</div>
													</div>
												</div>

												<div className="display-blok mt2 pv-top-card--reflow">
													<div className="flex-1 mr5 pv-top-card__list-container">
														<ul className="pv-top-card--list inline-flex align-items-center">
															<li className="inline t-24 t-black t-normal break-words">
																{this.state.rst.title}
															</li>
														</ul>
														<h2 className="mt1 t-18 t-black t-normal break-words">
															{this.state.rst.name_company}
														</h2>
														<div className="text-left slist mt2" dangerouslySetInnerHTML={{__html: this.state.rst.enroll_students}}></div>
													</div>
													<div>
														<ul className="pv-top-card--experience-lists text-center align-items-flex-end">
															<li>&nbsp;</li>
															<li>
																<div className="btn btn_confirm text-info mrlr-10"
																	 onClick={this.handleClickJoin.bind(this)}>Enroll
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</section>
									</div>

									<div className="scaffold-layout--static">
										<div className="scaffold-layout__content scaffold-layout__content--main">
											<main id="sub-main" className="scaffold-layout__main">
												<div id="ember3367" className="pv-oc ember-view">

													<section id="ember3482"
															 className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
														<div className="pv-profile-section__card-header">
															<h4 className="pv-profile-section__card-heading">
																Role Overview
															</h4>
														</div>
														<p id="ember3483"
														   className="pv-about__summary-text mt4 t-14 ember-view">
															{this.state.rst.descript}
														</p>
														<div className="mt5">
															{project_type != 'challenge' ?
															<ul className={parseInt(enable_compress) <= 0 ? "profile-skills__skill-list profile-skills__skill-list-full experiential" : "profile-skills__skill-list profile-skills__skill-list-full"}>
																{parseInt(enable_compress) <= 0?
																	""
																	:
																	<li className="profile-skills__skill">
																		<div className="t-13 t-bold t-black mb1">Compensation</div>
																		<button role="checkbox" aria-checked="false"
																				aria-label="Apache Kafka" id="ember1202"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">{cost_extent}</span>
																		</button>
																	</li>
																}
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Duration</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">&lt; 4 weeks</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Time commitment</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{apprx}</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Posted</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{ago}</span>
																	</button>
																</li>
															</ul>
															:
																<ul className={"profile-skills__skill-list profile-skills__skill-list-full challenge-step"}>
																	<li className="profile-skills__skill">
																		<div className="t-13 t-bold t-black mb1">Reward</div>
																		<button role="checkbox" aria-checked="false"
																				aria-label="Require.js" id="ember1203"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">{reward}</span>
																		</button>
																	</li>
																	<li className="profile-skills__skill">
																		<div className="t-13 t-bold t-black mb1">Duration</div>
																		<button role="checkbox" aria-checked="false"
																				aria-label="Require.js" id="ember1203"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">{expires}</span>
																		</button>
																	</li>
																	<li className="profile-skills__skill">
																		<div className="t-13 t-bold t-black mb1">Time Commitment</div>
																		<button role="checkbox" aria-checked="false"
																				aria-label="Require.js" id="ember1203"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">{allotted}</span>
																		</button>
																	</li>
																	<li className="profile-skills__skill">
																		<div className="t-13 t-bold t-black mb1">Posted</div>
																		<button role="checkbox" aria-checked="false"
																				aria-label="Require.js" id="ember1203"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">{ago}</span>
																		</button>
																	</li>
																</ul>
															}
														</div>
														{this.state.skillArr.length > 0 ?
															<div id="ember2761" className="ember-view pb15 mt5">
																<div className="t-13 t-bold t-black mb1">Skills and
																	expertise
																</div>
																<ul className="profile-skills__skill-list">
																	{this.state.skillArr}
																</ul>
															</div>
														: ""}
														<div id="ember2761" className="ember-view pb15 mt5">
															<div className="t-13 t-bold t-black mb1">Incentive</div>
															<ul className="profile-skills__skill-list">
																{incentive}
															</ul>
														</div>
														<div id="ember2761" className="ember-view pb15 mt5">
															<div className="t-13 t-bold t-black mb1">Duration</div>
															<ul className="profile-skills__skill-list">
																{duration}
															</ul>
														</div>
													</section>

													<ProfileReviews
														profileId={coach_id}
														my={false}/>
												</div>
											</main>
										</div>
										<div className="scaffold-layout__content scaffold-layout__content--main">
											<main className="scaffold-layout__main">
												<div id="ember83" className="pv-deferred-area mt4 ember-view">
													<div className="pv-deferred-area__content">
														<div className="artdeco-card">
															<section className="pt5 pb3 ph4">
																<h2 className="text-heading-medium">
																	About the company
																</h2>
																<ul className="pv-profile-pymk__list">
																	<li className="pv-pymk-section__member-container">
																		<div className="pv-top-card__photo-wrapper image-no-radius ml0">
																			<div className="presence-entity presence-entity--size-9 pv-top-card__image">
																				{parseInt(avatar.length) === 1 ?
																					<span>{f_char}</span>
																					:
																					<img title="Avatar"
																						 src={avatar}
																						 className="presence-entity__image  pv-top-card__photo image-no-radius lazy-image ghost-person ember-view"/>
																				}
																			</div>
																		</div>
																		<div className="pv-pymk-section__member-cta mt1">
																			<div
																				className="t-13 t-bold t-black mb1">Overview
																			</div>
																			<p className="t-14">
																				{item.tagline}
																			</p>
																		</div>
																	</li>
																	<li className="pv-pymk-section__member-container">
																		<div className="feed-identity-module__widgets mv3">
																			<div id="ember1138"
																				 className="feed-identity-module__entity-list entity-list-wrapper ember-view">
																				<ul className="entity-list row mg0">
																					<li className="entity-list-items">
																						<div id="ember1142"
																							 className="entity-item ember-view">
																							<div id="ember1143"
																								 className="ember-view full-width">
																								<div id="ember1144"
																									 className="ember-view">
																									<div
																										className="display-flex align-items-baseline">
																										<div
																											className="text-align-left">
																											<div
																												className="t-12 t-black t-bold mr2">
																												<span>No. of Employee:</span>
																											</div>
																										</div>
																										<div
																											className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
																											<span>{item.emp_company}</span>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</li>
																					<li className="entity-list-items">
																						<div id="ember1142"
																							 className="entity-item ember-view">
																							<div id="ember1143"
																								 className="ember-view full-width">
																								<div id="ember1144"
																									 className="ember-view">
																									<div
																										className="display-flex align-items-baseline">
																										<div
																											className="text-align-left">
																											<div
																												className="t-12 t-black t-bold mr2">
																												<span>Location:</span>
																											</div>
																										</div>
																										<div
																											className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
																											<span>{item.city_company}</span>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</li>
																				</ul>
																			</div>
																		</div>
																	</li>
																	<li className="pv-pymk-section__member-container">
																		<button
																			onClick={this.handleClick.bind(this, 'company/' + item.id_company)}
																			role="checkbox" aria-checked="false"
																			aria-label="Apache Kafka" id="ember1202"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																			className="artdeco-pill__text">Learn More</span>
																		</button>
																	</li>
																</ul>
															</section>
														</div>
													</div>
												</div>

												<div id="ember83" className={isSupported ? "pv-deferred-area mt4 ember-view" : "hide-el"}>
													<div className="pv-deferred-area__content">
														<div className="artdeco-card">
															<section className="pt5 pb3 ph4">
																<h2 className="text-heading-medium">
																	About the coach
																</h2>
																<ul className="pv-profile-pymk__list">
																	<li className="pv-pymk-section__member-container">
																		<div className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
																			<img title="Avatar"
																				 src={coach_avatar}
																				 className="presence-entity__image  pv-top-card__photo  lazy-image ghost-person ember-view"/>
																		</div>
																		<div className="pv-pymk-section__member-cta mt1">
																			<div className="t-13 t-bold t-black mb1 display-flex">
																				{coach_name}
																				<div className="enroll-verified">
																					<span onMouseOver={this.handleVerified.bind(this)} onClick={this.handleVerified.bind(this)} onMouseOut={this.handleVerified.bind(this)} className="up-badge up-badge-tagline line-height-0 up-badge-verified up-popper-trigger" tabIndex="0" role="button" aria-describedby="popper_1">
																						<div className="up-icon">
																							<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 14 14" role="img">
																								<path d="M13.72 7.03c.45-.56.34-1.39-.24-1.82l-.55-.41c-.34-.25-.53-.66-.51-1.08l.03-.68c.03-.72-.53-1.32-1.25-1.33h-.68c-.42 0-.81-.22-1.05-.57L9.11.57c-.39-.6-1.2-.75-1.79-.33l-.55.4c-.34.24-.79.3-1.18.15L4.95.55c-.67-.25-1.41.11-1.64.79l-.21.65c-.14.4-.46.71-.87.82l-.65.18C.89 3.19.5 3.92.71 4.6l.21.65c.13.41.04.85-.22 1.18l-.42.54c-.45.56-.34 1.39.24 1.81l.55.41c.34.25.53.66.51 1.08l-.03.68c-.03.72.54 1.32 1.25 1.33h.68c.42 0 .81.22 1.05.57l.37.57c.39.6 1.21.75 1.79.33l.55-.4c.34-.25.78-.31 1.18-.16l.64.24c.67.25 1.41-.1 1.64-.79l.21-.65c.13-.4.45-.71.86-.82l.65-.17c.69-.19 1.09-.92.87-1.61l-.21-.65c-.13-.4-.05-.85.22-1.18l.42-.53zM6.06 9.84L3.5 7.27l1.23-1.23 1.33 1.33 3.21-3.21L10.5 5.4 6.06 9.84z"></path>
																							</svg>
																						</div>
																					</span>
																					<span id="popper_1" className={this.state.verified ? "popper up-popover" : "hide-el"}>
																						<div className="size-sm display-verified">
																							<div className="popper-wrapper">
																								<div className="popper-inner">
																									<div className="popper-content">
																										<span>This coach’s identity has been verified.</span>
																									</div>
																								</div>
																							</div>
																						</div>
																					</span>
																				</div>
																			</div>
																			<p className="t-14">
																				{coach_tagline}
																			</p>
																		</div>
																	</li>
																	<li onClick={this.handleClick.bind(this, '/profile/coach/'+coach_id)} className="pv-pymk-section__member-container">
																		<button role="checkbox" aria-checked="false"
																				aria-label="Apache Kafka" id="ember1202"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">Learn More</span>
																		</button>
																	</li>
																</ul>
															</section>
														</div>
													</div>
												</div>

												<section id="ember3482"
														 className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
													<div className="pv-profile-section__card-header">
														<h4 className="pv-profile-section__card-heading">
															Your Instructions
														</h4>
													</div>
													<p id="ember3483"
													   className="pv-about__summary-text mt4 t-14 ember-view">
														You must be logged in to enroll. If you don't have an account, please register.
													</p>
													<div className="mt5">
														<ul className="profile-skills__skill-list">
															<li onClick={this.handleClick.bind(this, 'signin')} className="profile-skills__skill">
																<button className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view">
																	<span className="artdeco-pill__text">Login</span>
																</button>
															</li>
															<li onClick={this.handleClick.bind(this, 'signup')} className="profile-skills__skill mrlr-10">
																<button className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view">
																	<span className="artdeco-pill__text">Register</span>
																</button>
															</li>
														</ul>
													</div>
												</section>
											</main>
										</div>
									</div>
								</main>
							</div>
						</div>
					</div>
				:
					<div id="content" className="no-marging-top">
						<div className="container root-linkedin" id="root-linkedin">
							<div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
								<main id="main" className="scaffold-layout__main">
									<div>
										<img
											src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
											className="hidden" data-elementtiming="true" alt="" role="none"/>
										<section id="ember3348" className="artdeco-card ember-view pv-top-card">
											<div className="live-video-hero-image"
												 style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
												<div tabIndex="0" aria-label="Profile background"
													 className="profile-background-image">
													<div className="profile-background-image__image-container">
														<img
															className="profile-background-image__image full-width full-height"
															id="profile-background-image-target-image"
															alt="Background Image"
															src={imgUrl}
														/>
													</div>
												</div>
											</div>

											<div className="ph5 pb5">
												<div className="display-flex pv-top-card--reflow">
													<div className="pv-top-card--photo text-align-left">
														<div className="pv-top-card__photo-wrapper image-no-radius ml0">
															<div className="presence-entity presence-entity--size-9 pv-top-card__image">
																{parseInt(avatar.length) === 1 ?
																	<span>{f_char}</span>
																	:
																	<img title="Avatar"
																		 src={avatar}
																		 className="presence-entity__image  pv-top-card__photo image-no-radius lazy-image ghost-person ember-view"/>
																}
															</div>
														</div>
													</div>
												</div>

												<div className="display-flex mt2 pv-top-card--reflow">
													<div className="flex-1 mr5 pv-top-card__list-container">
														<ul className="pv-top-card--list inline-flex align-items-center">
															<li className="inline t-24 t-black t-normal break-words">
																{this.state.rst.title}
															</li>
														</ul>
														<h2 className="mt1 t-18 t-black t-normal break-words">
															{this.state.rst.name_company}
														</h2>
														<div className="text-left slist mt2" dangerouslySetInnerHTML={{__html: this.state.rst.enroll_students}}></div>
													</div>
													<div>
														<ul className="pv-top-card--experience-lists text-center align-items-flex-end">
															<li>&nbsp;</li>
															<li>
																<div className="btn btn_confirm text-info mrlr-10"
																	 onClick={this.handleClickJoin.bind(this)}>Enroll
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</section>
									</div>

									<div className="scaffold-layout--static">
										<div className="scaffold-layout__content scaffold-layout__content--main-aside">
											<main id="sub-main" className="scaffold-layout__main">
												<div id="ember3367" className="pv-oc ember-view">

													<section id="ember3482"
															 className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
														<div className="pv-profile-section__card-header">
															<h4 className="pv-profile-section__card-heading">
																Role Overview
															</h4>
														</div>
														<p id="ember3483"
														   className="pv-about__summary-text mt4 t-14 ember-view">
															{this.state.rst.descript}
														</p>
														{}
														<div className="mt5">
															{project_type != 'challenge' ?
															<ul className={parseInt(enable_compress) <= 0 ? "profile-skills__skill-list profile-skills__skill-list-full experiential" : "profile-skills__skill-list profile-skills__skill-list-full"}>
																{parseInt(enable_compress) <= 0 ?
																	""
																	:
																	<li className="profile-skills__skill">
																		<div className="t-13 t-bold t-black mb1">Compensation</div>
																		<button role="checkbox" aria-checked="false"
																				aria-label="Apache Kafka"
																				id="ember1202"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">{cost_extent}</span>
																		</button>
																	</li>
																}
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Duration</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">&lt; 4 weeks</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Time commitment</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{apprx}</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Posted</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{ago}</span>
																	</button>
																</li>
															</ul>
															:
															<ul className={"profile-skills__skill-list profile-skills__skill-list-full challenge-step"}>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Reward</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{reward}</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Duration</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{expires}</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Time Commitment</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{allotted}</span>
																	</button>
																</li>
																<li className="profile-skills__skill">
																	<div className="t-13 t-bold t-black mb1">Posted</div>
																	<button role="checkbox" aria-checked="false"
																			aria-label="Require.js" id="ember1203"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">{ago}</span>
																	</button>
																</li>
															</ul>
															}
														</div>
														{this.state.skillArr.length > 0 ?
															<div id="ember2761" className="ember-view pb15 mt5">
																<div className="t-13 t-bold t-black mb1">Skills and expertise </div>
																<ul className="profile-skills__skill-list">
																	{this.state.skillArr}
																</ul>
															</div>
														: ""}
															<div id="ember2761" className="ember-view pb15 mt5">
																<div className="t-13 t-bold t-black mb1">Incentive</div>
																<ul className="profile-skills__skill-list">
																	{incentive}
																</ul>
															</div>
															<div id="ember2761" className="ember-view pb15 mt5">
																<div className="t-13 t-bold t-black mb1">Duration</div>
																<ul className="profile-skills__skill-list">
																	{duration}
																</ul>
															</div>
													</section>

													<ProfileReviews
														profileId={coach_id}
														my={false}/>

													<section id="ember3482"
															 className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
														<div className="pv-profile-section__card-header">
															<h4 className="pv-profile-section__card-heading">
																Your Instructions
															</h4>
														</div>
														<p id="ember3483"
														   className="pv-about__summary-text mt4 t-14 ember-view">
															You must be logged in to enroll. If you don't have an account, please register.
														</p>
														<div className="mt5">
															<ul className="profile-skills__skill-list">
																<li onClick={this.handleClick.bind(this, 'signin')} className="profile-skills__skill">
																	<button className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view">
																		<span className="artdeco-pill__text">Login</span>
																	</button>
																</li>
																<li onClick={this.handleClick.bind(this, 'signup')} className="profile-skills__skill mrlr-10">
																	<button className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view">
																		<span className="artdeco-pill__text">Register</span>
																	</button>
																</li>
															</ul>
														</div>
													</section>
												</div>
											</main>
											<aside className="scaffold-layout__aside">
												<div id="ember83" className="pv-deferred-area mt4 ember-view">
													<div className="pv-deferred-area__content">
														<div className="artdeco-card">
															<section className="pt5 pb3 ph4">
																<h2 className="text-heading-medium">
																	About the company
																</h2>
																<ul className="pv-profile-pymk__list">
																	<li className="pv-pymk-section__member-container">
																		<div className="pv-top-card__photo-wrapper image-no-radius ml0">
																			<div className="presence-entity presence-entity--size-9 pv-top-card__image">
																				{parseInt(avatar.length) === 1 ?
																					<span>{f_char}</span>
																					:
																					<img title="Avatar"
																						 src={avatar}
																						 className="presence-entity__image  pv-top-card__photo image-no-radius lazy-image ghost-person ember-view"/>
																				}
																			</div>
																		</div>
																		<div className="pv-pymk-section__member-cta mt1">
																			<div
																				className="t-13 t-bold t-black mb1">Overview
																			</div>
																			<p className="t-14">
																				{item.tagline}
																			</p>
																		</div>
																	</li>
																	<li className="pv-pymk-section__member-container">
																		<div className="feed-identity-module__widgets mv3">
																			<div id="ember1138"
																				 className="feed-identity-module__entity-list entity-list-wrapper ember-view">
																				<ul className="entity-list row mg0">
																					<li className="entity-list-items">
																						<div id="ember1142"
																							 className="entity-item ember-view">
																							<div id="ember1143"
																								 className="ember-view full-width">
																								<div id="ember1144"
																									 className="ember-view">
																									<div
																										className="display-flex align-items-baseline">
																										<div
																											className="text-align-left">
																											<div
																												className="t-12 t-black t-bold mr2">
																												<span>No. of Employee:</span>
																											</div>
																										</div>
																										<div
																											className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
																											<span>{item.emp_company}</span>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</li>
																					<li className="entity-list-items">
																						<div id="ember1142"
																							 className="entity-item ember-view">
																							<div id="ember1143"
																								 className="ember-view full-width">
																								<div id="ember1144"
																									 className="ember-view">
																									<div
																										className="display-flex align-items-baseline">
																										<div
																											className="text-align-left">
																											<div
																												className="t-12 t-black t-bold mr2">
																												<span>Location:</span>
																											</div>
																										</div>
																										<div
																											className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
																											<span>{item.city_company}</span>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</li>
																				</ul>
																			</div>
																		</div>
																	</li>
																	<li className="pv-pymk-section__member-container">
																		<button
																			onClick={this.handleClick.bind(this, 'company/' + item.id_company)}
																			role="checkbox" aria-checked="false"
																			aria-label="Apache Kafka" id="ember1202"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																			className="artdeco-pill__text">Learn More</span>
																		</button>
																	</li>
																</ul>
															</section>
														</div>
													</div>
												</div>

												<div id="ember83" className={isSupported ? "pv-deferred-area mt4 ember-view" : "hide-el"}>
													<div className="pv-deferred-area__content">
														<div className="artdeco-card">
															<section className="pt5 pb3 ph4">
																<h2 className="text-heading-medium">
																	About the coach
																</h2>
																<ul className="pv-profile-pymk__list">
																	<li className="pv-pymk-section__member-container">
																		<div className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
																			<img title="Avatar"
																				 src={coach_avatar}
																				 className="presence-entity__image  pv-top-card__photo  lazy-image ghost-person ember-view"/>
																		</div>
																		<div className="pv-pymk-section__member-cta mt1">
																			<div className="t-13 t-bold t-black mb1 display-flex">
																				{coach_name}
																				<div className="about-verified">
																					<span onMouseOver={this.handleVerified.bind(this)} onMouseOut={this.handleVerified.bind(this)} className="up-badge up-badge-tagline line-height-0 up-badge-verified up-popper-trigger" tabIndex="0" role="button" aria-describedby="popper_1">
																						<div className="up-icon">
																							<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 14 14" role="img">
																								<path d="M13.72 7.03c.45-.56.34-1.39-.24-1.82l-.55-.41c-.34-.25-.53-.66-.51-1.08l.03-.68c.03-.72-.53-1.32-1.25-1.33h-.68c-.42 0-.81-.22-1.05-.57L9.11.57c-.39-.6-1.2-.75-1.79-.33l-.55.4c-.34.24-.79.3-1.18.15L4.95.55c-.67-.25-1.41.11-1.64.79l-.21.65c-.14.4-.46.71-.87.82l-.65.18C.89 3.19.5 3.92.71 4.6l.21.65c.13.41.04.85-.22 1.18l-.42.54c-.45.56-.34 1.39.24 1.81l.55.41c.34.25.53.66.51 1.08l-.03.68c-.03.72.54 1.32 1.25 1.33h.68c.42 0 .81.22 1.05.57l.37.57c.39.6 1.21.75 1.79.33l.55-.4c.34-.25.78-.31 1.18-.16l.64.24c.67.25 1.41-.1 1.64-.79l.21-.65c.13-.4.45-.71.86-.82l.65-.17c.69-.19 1.09-.92.87-1.61l-.21-.65c-.13-.4-.05-.85.22-1.18l.42-.53zM6.06 9.84L3.5 7.27l1.23-1.23 1.33 1.33 3.21-3.21L10.5 5.4 6.06 9.84z"></path>
																							</svg>
																						</div>
																					</span>
																										<span id="popper_1" className={this.state.verified ? "popper up-popover" : "hide-el"}>
																						<div className="size-sm display-verified">
																							<div className="popper-wrapper">
																								<div className="popper-inner">
																									<div className="popper-content">
																										<span>This coach’s identity has been verified.</span>
																									</div>
																								</div>
																							</div>
																						</div>
																					</span>
																				</div>
																			</div>
																			<p className="t-14">
																				{coach_tagline}
																			</p>
																		</div>
																	</li>
																	<li onClick={this.handleClick.bind(this, '/profile/coach/'+coach_id)} className="pv-pymk-section__member-container">
																		<button role="checkbox" aria-checked="false"
																				aria-label="Apache Kafka" id="ember1202"
																				className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																				type="button"><span
																			className="artdeco-pill__text">Learn More</span>
																		</button>
																	</li>
																</ul>
															</section>
														</div>
													</div>
												</div>
											</aside>
										</div>
									</div>
								</main>
							</div>
						</div>
					</div>
				}
			</div>
		)
	}
}

export default (withRouter(InternshipPublic));


/** WEBPACK FOOTER **
 ** ./src/client/app/iappcomponents/pages/internship-public.js
 **/